import React from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import { loginAction, setInfoAction, toggleLoadingAction, logoutAction } from '../../actions/global';
import { DOMAIN, CLIENT_ID, CLIENT_SECRET, REDIRECT_URI, SAS_URL, SAS_ENV } from '../../config/global';
import axios from 'axios';
import queryString from 'query-string';

class Home extends React.Component {
  componentDidMount() {
    localStorage.removeItem('selectedTab');
    let params = queryString.parse(this.props.location.search)
    let sub = null;
    let email = null;
    let username = null;
    if (params.code != null) {
      return this.props.toggleLoadingAction(true)
        .then(() => {
          return axios({
            method: 'post',
            url: `${DOMAIN}/oauth2/token`,
            data: queryString.stringify({
              grant_type: "authorization_code",
              client_id: CLIENT_ID,
              code: params.code,
              scope: 'profile',
              redirect_uri: REDIRECT_URI,
            }),
            auth: {
              username: CLIENT_ID,
              password: CLIENT_SECRET,
            },
          });
        }).then(result => {
          let { access_token, expires_in, id_token, refresh_token, token_type } = result.data;
          expires_in = expires_in * 1000 + Date.now();
          return this.props.loginAction({
            access_token,
            expires_in,
            id_token,
            refresh_token,
            token_type
          })
        }).then((result) => {
          return axios({
            method: 'get',
            url: `${DOMAIN}/oauth2/userInfo`,
            headers: {
              Authorization: `Bearer ${result.access_token}`
            }
          });
        }).then((result) => {
          sub = result.data.sub;
          email = result.data.email;
          username = result.data.username;
          return axios({
            method: 'get',
            url: `${SAS_URL}/mde/od/permissions?appCode=MDE&stage=${SAS_ENV}&version=1.0&login=${email}`,
          })
        }).then((result) => {
          let { authorizations } = result.data;
          if (authorizations.length === 0) {
            return message.error("You are not authorized to access. Please contact Skywise support team.", 3, () => {
              this.props.logoutAction();
            });
          } else {
            let permissionsResult = [];
            for (let i = 0; i < authorizations.length; i++) {
              let addNew = true;
              for (let j = 0; j < permissionsResult.length; j++) {
                if (permissionsResult[j] != null && permissionsResult[j].permissions && permissionsResult[j].company != null && permissionsResult[j].company.icao != null && authorizations[i] != null && authorizations[i].permissions && authorizations[i].company != null && authorizations[i].company.icao != null &&
                  permissionsResult[j].company.icao === authorizations[i].company.icao
                ) {
                  addNew = false;
                  for (let z = 0; z < authorizations[i].permissions.length; z++) {
                    if (!permissionsResult[j].permissions.includes(authorizations[i].permissions[z])) {
                      permissionsResult[j].permissions.push(authorizations[i].permissions[z]);
                    }
                  }
                  break;
                }
              }
              if (addNew === true) {
                permissionsResult.push(authorizations[i]);
              }
            }
            return this.props.setInfoAction({
              sub,
              email,
              username,
              permissions: permissionsResult
            });
          }
        }).then(() => {
          window.location = '/SDE';
        }).catch((error) => {
          this.props.toggleLoadingAction(false);
          message.error(JSON.stringify(error));
        });
    } else {
      window.location = '/SDE';
    }
  }

  render() {
    return <div />
  }
}

export default connect(null, { loginAction, logoutAction, setInfoAction, toggleLoadingAction })(Home)